export const columnasComprobantes = [
  {
    key: "comprobante",
    label: "Comprobante",
    sorted: true,
    fixed: false,
    type: "string",
    hidden: false,
  },
  {
    key: "caeCai",
    label: "CAE/CAI",
    sorted: true,
    fixed: false,
    type: "string",
    hidden: false,
  },
  {
    key: "numeroFactura",
    label: "Número Factura",
    sorted: true,
    fixed: false,
    type: "string",
    hidden: false,
  },
  {
    key: "razonSocial",
    label: "Razón Social",
    sorted: true,
    fixed: false,
    type: "string",
    hidden: false,
  },
  {
    key: "cuit",
    label: "CUIT",
    sorted: true,
    fixed: false,
    type: "string",
    hidden: false,
  },
  {
    key: "concepto",
    label: "Concepto",
    sorted: true,
    fixed: false,
    type: "string",
    hidden: false,
  },
  {
    key: "fecha",
    label: "Fecha",
    sorted: true,
    fixed: false,
    type: "date",
    hidden: false,
  },
  {
    key: "importeFormateado",
    label: "Importe",
    sorted: true,
    fixed: false,
    type: "number",
    hidden: false,
    sortKey: "currency"
  },
  {
    key: "edit",
    label: "",
    sorted: false,
    fixed: false,
    type: "component",
    hidden: false,
  },
  {
    key: "show",
    label: "",
    sorted: false,
    fixed: false,
    type: "component",
    hidden: false,
  },
  {
    key: "delete",
    label: "",
    sorted: false,
    fixed: false,
    type: "component",
    hidden: false,
  },
];
